import axios from 'axios';
import qs from 'qs';

export const getFigmaLessonById = ({
  lessonId,
  locale,
}: {
  lessonId: string;
  locale?: string;
}) =>
  axios.get(
    `/api/v1/figma-lessons/${lessonId}${locale ? `?${qs.stringify({ locale })}` : ''}`,
  );

export const createFigmaLesson = (data: any) =>
  axios.post('/api/v1/figma-lessons', data);

export const saveFigmaLessonMaterials = ({
  lessonId,
  data,
}: {
  lessonId: string;
  data: any;
}) => axios.put(`/api/v1/figma-lessons/${lessonId}/materials`, data);

export const saveFigmaLessonPreviews = ({
  lessonId,
  data,
}: {
  lessonId: string;
  data: { tasks?: any[]; initialState?: any };
}) =>
  axios.put<{
    tasks?: any[];
    initialState?: any;
    resultPreview?: string;
  }>(`/api/v1/figma-lessons/${lessonId}/previews`, data);

export const updateFigmaLessonById = ({
  lessonId,
  data,
}: {
  lessonId: string;
  data: any;
}) => axios.put(`/api/v1/figma-lessons/${lessonId}`, data);

export const removeFigmaLessonById = (lessonId: string) =>
  axios.delete(`/api/v1/figma-lessons/${lessonId}`);

export const translateTask = (lessonId: string, data: any) =>
  axios.post(`/api/v1/figma-lessons/${lessonId}/translate-task`, data);
